<template>
    <tr>
        <td>
            {{ status_prototype.scope }}
        </td>
        <td>
            <i class="plus icon" v-if="status_prototype.polarity == true"></i>
            <i class="minus icon" v-else-if="status_prototype.polarity == false"></i>
            {{ status_prototype.name }}
        </td>
        <td>
            {{ status_prototype.material_class_name || '-' }}
        </td>
        <td>
            <router-link
                :to="{name: 'edit_status_prototype', params: {identity: status_prototype.identity}}"
                class="ui basic positive button">
                {{ $t('ui.general.edit') }}
            </router-link>
        </td>
    </tr>
</template>

<script>
export default {
    name: "ProviderStatusPrototypesIndexItem",
    props: {
        status_prototype: Object
    },
    data() {
        return {
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>
